module.exports = __webpack_public_path__ + "img/logo_cj@3x.25c7dbe9.png";